const Aboutcp = ({ data }) => {
    const bgGradient = "linear-gradient(90deg, rgb(0, 222, 161) 0%, rgb(0, 222, 161) 10%, #3fb2dd 30%, hsl(220, 97.3%, 55.9%) 100%)";
    return (
        <section className="py-12">
            <div
                className="w-full"
                style={{ background: bgGradient }}
            >
                {/* 内部容器，宽度和 Navbar 对齐 */}
                <div className="mx-auto w-full px-4 sm:px-6 lg:w-[70%] lg:max-w-[1440px]">
                    <div className="pt-24 pb-20">
                        <h3 className="text-white text-4xl font-semibold sm:text-5xl">
                            {data.title}
                        </h3>
                    </div>
                </div>
            </div>

            {/* 下面的内容保持和Navbar宽度一致 */}
            <div className="mx-auto w-full px-4 sm:px-6 lg:w-[70%] lg:max-w-[1440px] mt-10 pt-14 text-gray-700">
                <div className=" mx-auto ">
                    <div className='relative space-y-3 '>
                        {data.items.map((item, idx) => (
                            <>
                                <h1 className="text-gray-800 font-bold text-4xl xl:text-5xl">
                                    {item.title}
                                </h1>

                                <div className='py-2  text-lg'>
                                    <p>
                                        {item.subTitle}
                                    </p>
                                </div>
                            </>
                        ))
                        }
                    </div>
                </div>
            </div>
        </section >
    );
};

export default Aboutcp;




